<template lang="html">
  <div class="agent-details-codes--inner">
    <div class="window-details-toolbar">
      <div class="window-details-toolbar__item">
        <search
          class="search-bar-wrap"
          :filterBy="filterBy"
          :dateBy="dateBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>

      </div>
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>
    <tbl
      :class="{'data-loading': showDataLoading}"
      :scrollable="true"
      v-else
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              :sort="true"
              @click.native="sort('id')"
              name="no"
            >
              no
            </tbl-td>

            <tbl-td
              :sort="true"
              @click.native="sort('code')"
              name="code"
            >
              code
            </tbl-td>
            <tbl-td
              :sort="true"
              @click.native="sort('bank_name')"
              class="bank-name"
            >
              bank name
            </tbl-td>
            <tbl-td
              :sort="true"
              @click.native="sort('bank_account_name')"
              class="bank-account-name"
            >
              bank account name
            </tbl-td>
            <tbl-td
              :sort="true"
              @click.native="sort('bank_number')"
              class="bank-account-number"
            >
              bank number
            </tbl-td>
            <tbl-td name="active">
              active
            </tbl-td>
            <tbl-td
              :sort="true"
              @click.native="sort('created_at')"
              name="date"
            >
              created at
            </tbl-td>
            <tbl-td
              :sort="true"
              @click.native="sort('deleted_at')"
              name="date"
            >
              deleted at
            </tbl-td>

          </tbl-row>
        </tbl-head>
        <tbl-body>
          <tbl-row
            v-for="(code, x) in agentCodes"
            :key="code.id"
          >
            <tbl-td
              name="no"
            >
              {{ generateNumber(x, params.page, params.rows, params.sort, agentCodesCnt || 0) }}
            </tbl-td>

            <tbl-td name="code">
              {{code.code}}
            </tbl-td>
            <tbl-td name="bank-name">
              <ul
                class="tbl-subcells col3"
                v-for="(wallet, i) in code.deposit"
                :key="wallet.id"
              >
                <li class="bank-name">
                  <span>{{ wallet.bank_name }}</span>
                </li>
              </ul>
            </tbl-td>
            <tbl-td name="bank-account-name">
              <ul
                class="tbl-subcells col3"
                v-for="(wallet, i) in code.deposit"
                :key="wallet.id"
              >
                <li class="bank-account-name">
                  <span>{{ wallet.bank_account_name }}</span>
                </li>
              </ul>
            </tbl-td>

            <tbl-td name="bank-number">
              <ul
                class="tbl-subcells col3"
                v-for="(wallet, i) in code.deposit"
                :key="wallet.id"
              >
                <li class="bank-number">
                  <span>{{ wallet.bank_number }}</span>
                </li>
              </ul>
            </tbl-td>

            <tbl-td name="active">
              {{code.active}}
            </tbl-td>

            <tbl-td name="date">
              {{code.created_at | date}}
            </tbl-td>

            <tbl-td name="date">
              {{code.deleted_at | date}}
            </tbl-td>

          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="agentCodesCnt"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>

    </tbl>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Pagination from '@/components/base/Pagination'

export default {
  name: 'agent-detail-codes',

  components: {
  	Search,
  	CheckDataList,
    Pagination
  },

  computed: {
  	...mapState('agent', ['agentCodes', 'agentCodesCnt'])
  },
  created () {
  	this.search(this.generate(this.params))
  },
  data () {
    let params = Object.assign(
      {
        rows: 15,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

  	return {
      params,
      filterBy: [
        {
          value: 'bank_account_name',
          display: 'bank account name'
        },

        {
          value: 'bank_number',
          display: 'bank account number'
        },

        {
          value: 'bank_name',
          display: 'bank name'
        },

        {
          value: 'code',
          display: 'code'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false
  	}
  },

  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },
  methods: {
  	...mapActions('agent', ['getCodes']),
    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    }, // trigger
  	async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

  		await this.getCodes({ id: this.$route.params.id, params: this.params })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.agentCodes.length) {
        this.isEmpty = true
      }
  	},
    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }
  		await this.getCodes({ id: this.$route.params.id, params: this.params })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.agentCodes.length) {
        this.isEmpty = true
      }
  	}
  }
}
</script>
